<template>
  <!-- 优秀视频展示 -->
  <div class="main-contain">
    <el-image class="elimage" :src="testimage" />
    <el-image class="elimage" :src="testimage" />
    <el-image class="elimage" :src="testimage" />
    <el-image class="elimage" :src="testimage" />
    <el-image class="elimage" :src="testimage" />
    <el-image class="elimage" :src="testimage" />
    <el-image class="elimage" :src="testimage" />
  </div>
</template>
<script>
export default {
  name: "Courseintroduction",
  components: {},
  data() {
    return {
      testimage: require("@/assets/test.png"),
    };
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.main-contain {
  margin-top: 20px;
//   border: 1px solid red;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  height: 400px;
  overflow-y: auto;
  .elimage {
    margin-top: 10px;
    margin-right: 50px;
    width: 233px;
    height: 158px;
    border-radius: 4px;
  }
}
</style>
